/* Muted brand film: preserve manual pause across visibility and source changes. */
(() => {
  const heroes = new Map();
  function setupHero(root) {
    const video = root.querySelector('[data-brand-video]');
    const toggle = root.querySelector('[data-film-toggle]');
    if (!video || !toggle || heroes.has(root)) return;
    const events = new AbortController();
    const options = { signal: events.signal };
    const mobile = window.matchMedia('(max-width: 749px)');
    let userPaused = false;
    let selectedUrl = '';
    let requestId = 0;
    let disposed = false;
    function button(playing) {
      toggle.hidden = false;
      toggle.textContent = playing ? 'Pause film' : 'Play film';
      toggle.setAttribute('aria-label', playing ? 'Pause brand film' : 'Play brand film');
    }
    function fallback() {
      video.classList.remove('is-playing');
      button(false);
    }
    function pause() {
      requestId += 1;
      video.pause();
      button(false);
    }
    function play() {
      if (disposed || document.hidden || userPaused || !selectedUrl) return;
      const request = ++requestId;
      video.defaultMuted = true;
      video.muted = true;
      Promise.resolve(video.play()).catch(() => {
        if (!disposed && request === requestId) fallback();
      });
    }
    function load() {
      const desktop = [...video.querySelectorAll('[data-desktop-source]')];
      const phone = [...video.querySelectorAll('[data-mobile-source]')];
      const sources = mobile.matches && phone.length ? phone : desktop.length ? desktop : phone;
      const source = sources.sort((a, b) => Number(b.dataset.width) - Number(a.dataset.width))[0];
      const url = source?.dataset.src || '';
      if (url === selectedUrl && url && !video.error) { play(); return; }
      pause(); fallback(); selectedUrl = url;
      video.autoplay = !userPaused && !document.hidden;
      video.defaultMuted = true; video.muted = true;
      if (!url) return;
      video.src = url; video.load(); play();
    }
    video.addEventListener('playing', () => {
      if (disposed || document.hidden || userPaused) { pause(); return; }
      video.classList.add('is-playing'); button(true);
    }, options);
    video.addEventListener('pause', () => button(false), options);
    video.addEventListener('error', fallback, options);
    video.addEventListener('stalled', () => { if (video.readyState < 2) fallback(); }, options);
    toggle.addEventListener('click', () => {
      if (!video.paused) { userPaused = true; pause(); }
      else {
        userPaused = false;
        if (video.error || !selectedUrl) load();
        else play();
      }
    }, options);
    mobile.addEventListener('change', load, options);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause(); else play();
    }, options);
    window.addEventListener('pagehide', pause, options);
    window.addEventListener('pageshow', play, options);
    heroes.set(root, () => { disposed = true; requestId += 1; events.abort(); video.pause(); });
    load();
  }
  let headerObserver;
  let layoutFrame;
  function measureHeader() {
    layoutFrame = null;
    if (!document.documentElement.classList.contains('syk-home')) return;
    const height = [...document.querySelectorAll('.syk-announcement, .syk-header')]
      .reduce((total, element) => total + element.getBoundingClientRect().height, 0);
    document.documentElement.style.setProperty('--syk-header-height', `${Math.round(height)}px`);
  }
  function scheduleMeasure() {
    if (layoutFrame == null) layoutFrame = window.requestAnimationFrame(measureHeader);
  }
  function observeHeader() {
    if (!document.documentElement.classList.contains('syk-home')) return;
    headerObserver?.disconnect();
    headerObserver = new ResizeObserver(scheduleMeasure);
    document.querySelectorAll('.syk-announcement, .syk-header').forEach(element => headerObserver.observe(element));
    scheduleMeasure();
  }
  function setup(scope = document) {
    scope.querySelectorAll('[data-syk-video-hero]').forEach(setupHero);
    observeHeader();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    heroes.forEach((dispose, root) => {
      if (event.target.contains(root)) { dispose(); heroes.delete(root); }
    });
    observeHeader();
  });
  document.addEventListener('shopify:section:reorder', observeHeader);
  window.addEventListener('resize', scheduleMeasure);
})();
